import React from 'react';
import _ from 'lodash';

const BaderLine = (props) => {
  const { bader } = props.structure;
  const { wyckoffsDetail } = props.structure.relaxedStructure;

  const baderTable = {};

  bader.forEach((obj, index) => {
    if (!baderTable[Object.keys(obj)[0]]) {
      baderTable[Object.keys(obj)[0]] = {};
    }
    if (!baderTable[Object.keys(obj)[0]][wyckoffsDetail[index]]) {
      baderTable[Object.keys(obj)[0]][wyckoffsDetail[index]] = [];
    }

    return baderTable[Object.keys(obj)[0]][wyckoffsDetail[index]].push(Object.values(obj)[0]);
  });


  return <tbody>
    { _.map(baderTable, (baderItem, elm) =>
      _.map(baderItem, (values, wyckoff) => {
        const val = values.reduce((a, b) => a + b) / values.length;
        return (
          <tr key={`${elm}-${wyckoff}`}>
            <td className="text-center">{elm}</td>
            <td className="text-center">{values.length}{wyckoff}</td>
            <td className="text-center">{val > 0 ? `+${val.toFixed(3)}` : val.toFixed(3)}</td>
          </tr>
        )
      })
    )}
  </tbody>
}

export default BaderLine;



// WEBPACK FOOTER //
// ./src/containers/structures/baderLine.js